import React, { useState } from "react";
import { FreshWaterGeneratorComList } from "./FreshWaterGeneratorComList";
import { AirCompressorComList } from "./AirCompressorComList";
import { RefrigerationComList } from "./RefrigerationComList";
import { OtherComList } from "./OtherComList";

function OtherMachinary({ eng_log_basic_id }) {
  const [activeTab, setActiveTab] = useState("Fresh Water Generator");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "Fresh Water Generator" ? "active" : ""}
            onClick={() => handleClick("Fresh Water Generator")}
          >
            Fresh Water Generator
          </li>
          <li
            className={
              activeTab === "Air Conditioning Generator" ? "active" : ""
            }
            onClick={() => handleClick("Air Conditioning Generator")}
          >
            Air Conditioning Plant
          </li>

          <li
            className={activeTab === "Refrigeration Plant" ? "active" : ""}
            onClick={() => handleClick("Refrigeration Plant")}
          >
            Refrigeration Plant
          </li>
          <li
            className={activeTab === "Other" ? "active" : ""}
            onClick={() => handleClick("Other")}
          >
            Other
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "Fresh Water Generator" && (
          <FreshWaterGeneratorComList id={eng_log_basic_id} />
        )}
        {activeTab == "Air Conditioning Generator" && (
          <AirCompressorComList id={eng_log_basic_id} />
        )}
        {activeTab == "Refrigeration Plant" && (
          <RefrigerationComList id={eng_log_basic_id} />
        )}
        {activeTab == "Other" && <OtherComList id={eng_log_basic_id} />}
      </div>
    </>
  );
}

export default OtherMachinary;
